<template> 
  <product-detail  :is-edit='false'></product-detail>
  <!-- -->
</template>
<script>
  import ProductDetail from './components/ProductDetail'
  export default {
    name: 'detailProduct',
    components: { ProductDetail }
  }
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/views/pms/product/detail.vue